/** Human-friendly byte formatting (1024-based). */
export function formatBytes(bytes: number, decimals = 1): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(i === 0 ? 0 : decimals)} ${units[i]}`;
}

/** Compact integers, e.g. 1200 -> 1.2k. */
export function formatCount(n: number): string {
  return new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
}

/**
 * The domain part of an email address (or the input unchanged when it has no
 * `@`). Shared by the investigation drawers for building domain-scoped
 * deep-links (previously copy-pasted per drawer).
 */
export function domainOf(addr: string): string {
  return addr.includes('@') ? addr.split('@').pop() ?? '' : addr;
}

/** Relative time from an ISO string, e.g. "3m ago". */
export function formatRelative(iso: string): string {
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return '';
  const diff = Date.now() - then;
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });
  const units: Array<[Intl.RelativeTimeFormatUnit, number]> = [
    ['day', 86400000], ['hour', 3600000], ['minute', 60000], ['second', 1000],
  ];
  for (const [unit, ms] of units) {
    if (abs >= ms || unit === 'second') {
      return rtf.format(-Math.round(diff / ms), unit);
    }
  }
  return '';
}
